import { TabsContent, TabsTrigger, TabsList, Tabs } from "@/components/ui/tabs";
import MonitoringTabContent, {
  type ClientAddCardData,
} from "./MonitoringTabContent";
import type { MonitoringType } from "@/constants/monitoring";
import type { SelectedPlan } from "../../hooks/useClientPlans";

interface TabConfig {
  value: MonitoringType;
  label: string;
  cards: ClientAddCardData[];
}

interface MonitoringTabsProps {
  tabConfigs: TabConfig[];
  tabDisabled: Record<MonitoringType, boolean>;
  selectedPlans: Map<string, SelectedPlan>;
  isEditMode?: boolean;
  onDisabledChange: (monitoringType: MonitoringType, disabled: boolean) => void;
  onPlatformChange: (
    monitoringType: MonitoringType,
    planId: string,
    planTitle: string,
    platforms: string[],
    price: string,
    included?: string[],
  ) => void;
}

export function MonitoringTabs({
  tabConfigs,
  tabDisabled,
  selectedPlans,
  isEditMode = false,
  onDisabledChange,
  onPlatformChange,
}: MonitoringTabsProps) {
  return (
    <Tabs defaultValue="keyword">
      <TabsList className="bg-black-950 !h-[52px]">
        {tabConfigs.map(({ value, label }) => (
          <TabsTrigger
            key={value}
            value={value}
            className="data-[state=active]:text-black-950 text-white transition-all duration-200"
          >
            {label}
          </TabsTrigger>
        ))}
      </TabsList>

      {tabConfigs.map(({ value, cards }) => (
        <TabsContent key={value} value={value}>
          <MonitoringTabContent
            monitoringType={value}
            cards={cards}
            disabled={tabDisabled[value]}
            isEditMode={isEditMode}
            onDisabledChange={(disabled) => onDisabledChange(value, disabled)}
            selectedPlans={selectedPlans}
            onPlatformChange={(planId, planTitle, platforms, price, included) =>
              onPlatformChange(
                value,
                planId,
                planTitle,
                platforms,
                price,
                included,
              )
            }
          />
        </TabsContent>
      ))}
    </Tabs>
  );
}
